import { NOTIFICATION_TITLES } from '@/constants/notifications'
import { showValidationMessage } from '@/lib/utils/notifications'

/** Angular `yardi-invite-add` — property not active with Yardi (`notify(..., 0)`). */
export function propertyNotActiveWithYardiMessage(propertyName: string): string {
  return `The property <b>"${propertyName}"</b> is not active with Yardi. To add an invite, the property must be active with Yardi.`
}

/** Angular `yardi-invite-add` — company not active with Yardi (`notify(..., 0)`). */
export function companyNotActiveWithYardiMessage(companyName: string): string {
  return `The company <b>"${companyName}"</b> is not active with Yardi. To add an invite, the company must be active with Yardi.`
}

/** Show validation modals one at a time; each next opens after Ok (Angular `notify(..., 0)` parity). */
export function showValidationModalsSequential(messages: string[]): void {
  if (messages.length === 0) return
  const [first, ...rest] = messages
  showValidationMessage(first, NOTIFICATION_TITLES.error, () => {
    showValidationModalsSequential(rest)
  })
}
